import { render, staticRenderFns } from "./truckNo.vue?vue&type=template&id=08267792&scoped=true&"
import script from "./truckNo.vue?vue&type=script&lang=js&"
export * from "./truckNo.vue?vue&type=script&lang=js&"
import style0 from "./truckNo.vue?vue&type=style&index=0&id=08267792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08267792",
  null
  
)

export default component.exports